import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import AddressTable from 'components/AddressTable';
import { saveAddress } from 'actions/addresses';
import { findUser } from 'actions/users';
import EditAddressModal from 'components/modals/EditAddressModal';
import { getLoggedInUser } from 'reducers';
import { can, permActions } from '../../permissions';

class Address extends Component {
  state = {
    loading: false,
    isOpenEditAddress: false,
  };

  openEditAddress = () => this.setState({ isOpenEditAddress: true });
  closeEditAddress = () => this.setState({ isOpenEditAddress: false });

  handleSaveAddress = (values) => {
    const { saveAddress, findUser, address } = this.props;
    this.setState({ loading: true });
    return saveAddress(values)
      .then(() => {
        return findUser(address.user_profile);
      })
      .then(() => {
        this.closeEditAddress();
        toast.success('Address Updated');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { user, address, loggedInUser } = this.props;
    const { loading, isOpenEditAddress } = this.state;
    const canEditAddress = can(loggedInUser, permActions.EDIT_ADDRESS, {
      loggedInUser,
      userId: user.id,
    });
    const showEdit = user?.is_active && canEditAddress;
    return (
      <div id="user-address" className="relative">
        <div className="d-flex-vc" style={{ marginBottom: '10px' }}>
          <h4>Address</h4>
          {showEdit && (
            <button
              className="btn btn-default mar-l"
              onClick={this.openEditAddress}
            >
              Edit Address
            </button>
          )}
        </div>
        <AddressTable address={address} />
        {showEdit && (
          <EditAddressModal
            isOpen={isOpenEditAddress}
            address={address}
            saveAddress={this.handleSaveAddress}
            onClose={this.closeEditAddress}
            loading={loading}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});

const mapDispatchToProps = {
  saveAddress,
  findUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Address);
